import { get, put,Delete,post } from '../axios'

// 断路器数据-列表
export const deviceList = params => get(`/web/collect/device/list`,params);


